export default "__VITE_ASSET__7790f4d9__"